import { render } from "./blog-section.vue?vue&type=template&id=648e5980"
import script from "./blog-section.vue?vue&type=script&lang=js"
export * from "./blog-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__